import api from "./apiURL";

// Map timeframe to API format
const getTimePeriodForAPI = (timeframe) => {
  switch (timeframe) {
    case "Today":
      return "today";
    case "Last 7 days":
      return "last7days";
    case "Last 30 days":
      return "last30days";
    case "Over All":
      return "alltime";
    default:
      return "alltime";
  }
};

export async function getSessionDetails(timePeriod = "Over All") {
  try {
    const apiTimePeriod = getTimePeriodForAPI(timePeriod);
    const response = await api.get(`/api/v1/user/session/get?timePeriod=${apiTimePeriod}`);
    return response.data;
  } catch (error) {
    // Handle the error
    console.log(error);
  }
}
